import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableFunctionsService } from '@services/table/table-functions.service';
import '@angular/localize/init';
import { ComponentBase } from '@abstracts/component-base';
import { Injector } from '@angular/core';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss']
})
export class ManageComponent extends ComponentBase  implements OnInit {

  public className = 'ManageComponent';
  public activeTab = 'users';

  public activeComponentClassName: string;

  links = [
    { title: $localize`:@@ManageTitel1:Benutzer`, route: 'users', icon: 'users' },
    //{ title: $localize`:@@ManageTitel3:RFID-Karten`, route: 'rfid', icon: 'rfid-card' },
    //{ title: $localize`:@@ManageTitel5:Nicht zugeteilte RFID-Karten`, route: 'unassigned-rfid', icon:'rfid-card' },
    //{ title: $localize`:@@ManageTitel4:Profil`, route: 'profile', icon: 'settings' }
  ];

  constructor(public tableFunctions: TableFunctionsService, public router: Router, public activatedRoute: ActivatedRoute, injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.determineActiveTab();
  }

  public onRouterOutletActivate(event: any) {
    this.activeComponentClassName = event.className;
  }

  determineActiveTab() {
    for (let link of this.links) {
      if (this.router.url.includes(link.route)) {
        this.activeTab = link.route;
      }
    }
  }
}
